import { render, staticRenderFns } from "./ItemLinha.vue?vue&type=template&id=887eacf8"
import script from "./ItemLinha.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemLinha.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemLinha.vue?vue&type=style&index=0&id=887eacf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports